import { QeFormData } from "components/Ielts/SelfPrepPrePayment/DataMapper/intefaces"
import api from "service/api"

export enum ieltsFormIds {
  D2C_FORM = "D2C Form",
  MOCK_FORM = "mock_form",
  DEMO_PROG_FORM = "Demo Prog Form",
  IELTS_DEMO_FORM = "Ielts Demo Form",
  T2I_FORM = "T2I Form",
  IELTS_DEMO_MC_FORM = "Ielts Demo MC Form",
}

export enum LeadSources {
  MARKETING = "Marketing", //this is WEBFLOW PAGE
  WEB_DASHBOARD = "Web Dashboard", //profile/ielts dashoard
  WEB_DAIGNOSTIC_TESTS = "Web Diagnostic Test", //profile/ielts/mocktest MOCKTESTS DASHBOARD
  OTHER = "Other", //default one
  ASYNC_DEMO_SCREEN = "Async Demo Screen",
  MARKETING_DEMO_MC = "Marketing Demo MC",
  SEO_LISTING_PAGE = "SEO Listing Page",
  RESCHEDULE_DASHBOARD = "Reschedule Dashboard",
  TOFU_DISQUALIFIED_CALENDAR = "Tofu Disqualified",
}

export const getPageContentForEvent = (currentFormStep: number): string => {
  switch (currentFormStep) {
    case 1: {
      return "Ielts Type"
    }
    case 2: {
      return "Career Stage"
    }
    case 3: {
      return "Ielts Time"
    }
    case 4: {
      return "User Contact Info"
    }
    default: {
      return "Ielts Type"
    }
  }
}

export const demoAliasQueryConstant = "alias"
export const demoAliasConstant = {
  masterclass: "masterclass",
}

export const checkQeFormFilled = (qeFormData: QeFormData | null): boolean => {
  if (
    qeFormData?.ieltsExamType &&
    qeFormData.whatCareerStage &&
    qeFormData.whenIelts &&
    qeFormData.emailId &&
    qeFormData.phone &&
    qeFormData.name
  )
    return true
  return false
}

export const getFormId = (
  isDisqualifiedUser: boolean,
  isMasterclassAlias: boolean,
): ieltsFormIds => {
  if (isDisqualifiedUser) return ieltsFormIds.T2I_FORM
  else {
    if (isMasterclassAlias) return ieltsFormIds.IELTS_DEMO_MC_FORM
    else return ieltsFormIds.IELTS_DEMO_FORM
  }
}

export const fetchCityApi = async (query: string): Promise<string[]> => {
  try {
    const res = await api.get(
      `/api/scholarRoute?path=api/autocomplete?prefix=${query}`,
    )
    if (res.data.success) return res.data.data
    else return []
  } catch (error) {
    console.log(error)
    return []
  }
}
